import { Modal, ROLE, SIZE as MODAL_SIZE } from 'baseui/modal'
import AbandonModalContent from '@/shared/components/contracts/AbandonModalContent'
import CommentsModalContent, { CommentItem } from '@/shared/components/contracts/CommentsModalContent'

interface ContractActionsModalProps {
  isOpen: boolean
  modalType: string
  onClose: () => void
  onAbandonSubmit: (reason: string, callback: (success: boolean) => void) => void
  onCommentSubmit: (comment: string, callback: (success: boolean) => void) => void
  comments: CommentItem[]
  isLoadingComments: boolean
}

const ContractActionsModal = ({
  isOpen,
  modalType,
  onClose,
  onAbandonSubmit,
  onCommentSubmit,
  comments,
  isLoadingComments,
}: ContractActionsModalProps) => (
  <Modal onClose={onClose} isOpen={isOpen} animate autoFocus size={MODAL_SIZE.auto} role={ROLE.dialog}>
    <AbandonModalContent onSubmit={onAbandonSubmit} minLength={10} hidden={modalType !== 'abandon'} />
    {modalType === 'comments' && (
      <CommentsModalContent comments={comments} onSubmit={onCommentSubmit} isLoadingComments={isLoadingComments} />
    )}
  </Modal>
)

export default ContractActionsModal
